import * as React from 'react';
import { WTableFilterVorhanden } from './WTableFilterVorhanden';
import { WTableFilterVorhandenSelect } from './WTableFilterVorhandenSelect';

export function generateVorhandenFilter(key: string, beispiel: JSX.Element, onChange: (value?: any) => void, item?: any) {
    // return <WTableFilterVorhanden onChange = {onChange} item={item}/>;
    return <div><WTableFilterVorhandenSelect onChange={onChange} item={item} />{beispiel}</div>;
}
